export const getBadgeTextSize = (badgeCount: number) =>
  badgeCount > 99 ? 'sm' : badgeCount > 9 ? 'md' : 'lg';
